export const parseBannerSlides = (value = "", linkUrl = "") => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      // Always return from here for valid JSON arrays — even empty ones.
      // Filter out any slide whose image URL is missing or blank.
      return parsed.filter((s) => s?.image && String(s.image).trim());
    }
  } catch {}
  // Legacy: value is a plain image URL string (not JSON)
  const trimmed = String(value).trim();
  if (!trimmed) return [];
  return [{ image: trimmed, link: linkUrl || "" }];
};
